import styles from './JobClassification.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { ScreenReaderOnly } from 'seek-style-guide/react';
import QualifiedLink from 'QualifiedLink/QualifiedLink';
import { ChevronIcon } from 'seek-style-guide/react';
import { jobClassificationClicked, jobSubclassificationClicked } from 'store/search/search';

const mapDispatchToProps = dispatch => ({
  onClassificationClick: () => dispatch(jobClassificationClicked()),
  onSubclassificationClick: () => dispatch(jobSubclassificationClicked())
});

@connect(null, mapDispatchToProps)
export default class JobClassification extends Component {

  static propTypes = {
    classification: PropTypes.object.isRequired,
    subClassification: PropTypes.object, // The Search API doesn't provide the subclassification for graduate jobs (don't ask me why)
    onClassificationClick: PropTypes.func.isRequired,
    onSubclassificationClick: PropTypes.func.isRequired
  };

  render() {
    const {
      classification, subClassification,
      onClassificationClick, onSubclassificationClick
    } = this.props;

    return (
      <p className={styles.root}>
        <ScreenReaderOnly>Classification: </ScreenReaderOnly>
        <QualifiedLink
          className={styles.link}
          path="/jobs"
          params={classification.params}
          onClick={onClassificationClick}
          scrollToTop={true}
          title={classification.title}
          aria-label={classification.title}
          data-automation="jobClassification">
          {classification.name}
        </QualifiedLink>
        {
          subClassification &&
            <ChevronIcon
              className={styles.arrowContainer}
              svgClassName={styles.arrowSvg}
              direction="right"
            />
        }
        {
          subClassification &&
            <QualifiedLink
              className={styles.link}
              path="/jobs"
              params={subClassification.params}
              onClick={onSubclassificationClick}
              scrollToTop={true}
              title={subClassification.title}
              aria-label={subClassification.title}
              data-automation="jobSubClassification">
              {subClassification.name}
            </QualifiedLink>
        }
      </p>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SearchResultList/components/JobItem/components/JobClassification/JobClassification.js
 **/